$('.search-btn').click(function(){
    setTimeout(function(){
        $('#searchModal input').focus();
    }, 1000);
})
